import { render } from "./MethodsGroup.vue?vue&type=template&id=7c54c43c&lang=pug"
import script from "./MethodsGroup.vue?vue&type=script&lang=js"
export * from "./MethodsGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__